import React, { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/Components/shadcn';
import { useCreateRecruitmentContext } from '../../../../Create/Contexts/CreateRecruitmentContext';
import { TestSelectionFormValues } from '../../SelectTestsStep';
import UIStrings from '@/Utils/UIStrings';

export interface SelectTestsStepperNavigationButtonsProps {
    activeStep: number;
    handleBack?: () => void;
    nextButtonComponent: ReactNode;
    centeredComponent: ReactNode;
}

export const SelectTestsStepperNavigationButtons = ({
    activeStep,
    handleBack,
    nextButtonComponent,
    centeredComponent,
}: SelectTestsStepperNavigationButtonsProps): React.JSX.Element => {
    const { setTestLanguage } = useCreateRecruitmentContext();
    const { getValues } = useFormContext<TestSelectionFormValues>();

    const handleBackWrapper = () => {
        setTestLanguage(getValues('testLanguageField'));

        if (handleBack) {
            handleBack();
        }
    };

    return (
        <div className="mt-8">
            <div className="flex flex-row items-center justify-between gap-4">
                {handleBack && (
                    <Button
                        type="button"
                        variant="outline"
                        size="default"
                        disabled={activeStep === 0}
                        onClick={handleBackWrapper}
                        className="gap-2"
                    >
                        <ChevronLeft className="size-4 shrink-0" aria-hidden />
                        {UIStrings.Back}
                    </Button>
                )}
                {centeredComponent}
                {nextButtonComponent && nextButtonComponent}
            </div>
        </div>
    );
};
